import { defineStore } from 'pinia';
import { useToast } from 'cc-prime';

export const useToastStore = defineStore('toast', () => {
  const toast = useToast();

  function add(options) {
    toast.add({ ...options });
  }

  return {
    add,
  };
});
